import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Primitive"], {
        "data-slot": "button",
        "data-variant": $props.variant,
        "data-size": $props.size,
        as: $props.as,
        "as-child": $props.asChild,
        class: _normalizeClass($setup.cn($setup.buttonVariants({ variant: $props.variant, size: $props.size }), $setup.props.class))
    }, {
        default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["data-variant", "data-size", "as", "as-child", "class"]));
}
